export * from './post-ort.component';
export * from './post-ort.component.module';